<div class="flex flex-row items-center flex-1 mt-2 p-2 background-cards rounded">
  <cds-svg-icon class="w-4 mx-2" name="input-error"></cds-svg-icon>
  <div class="self-center text-xs" data-test="input-error-text">{{text}}</div>
</div>
